 
  <div class="card mb-3">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.send_notifications' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Employees
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text px-2 pb-2">  {{ 'MENU.DASHBOARD.create_and_send_notifications_easily' | translate }}</p>
          </div>
        </div>
 
 
 <div class="container">
        <!-- <header>
          <h4 class="card-title">{{ 'MENU.DASHBOARD.send_notifications' | translate }}  </h4>
          <div class="card-body">
            <p class="card-text mt-2"> {{ 'MENU.DASHBOARD.create_and_send_notifications_easily' | translate }}   </p>
          </div>
        </header> -->

        <div class="main-content" style="display: flex; justify-content: center; width: 100%;">
            <section class="form-section">
                <h2 class="section-title">{{ 'MENU.DASHBOARD.create_new_notification' | translate }}  </h2>
                
<!-- Notification Title (Arabic) -->
<div class="form-group">
  <label for="titleAr">{{ 'MENU.DASHBOARD.notification_title_ar' | translate }}</label>
  <input
    type="text"
    id="titleAr"
    [(ngModel)]="formData.title_ar"
    name="title_ar"
    placeholder="{{ 'MENU.DASHBOARD.notification_title_ar' | translate }}"
    class="form-control"
  />
</div>

<!-- Notification Title (English) -->
<div class="form-group">
  <label for="titleEn">{{ 'MENU.DASHBOARD.notification_title_en' | translate }}</label>
  <input
    type="text"
    id="titleEn"
    [(ngModel)]="formData.title_en"
    name="title_en"
    placeholder="{{ 'MENU.DASHBOARD.notification_title_en' | translate }}"
    class="form-control"
  />
</div>

<!-- Notification Body (Arabic) -->
<div class="form-group">
  <label for="bodyAr">{{ 'MENU.DASHBOARD.notification_content_ar' | translate }}</label>
  <textarea
    id="bodyAr"
    [(ngModel)]="formData.body_ar"
    name="body_ar"
    placeholder="{{ 'MENU.DASHBOARD.notification_content_ar' | translate }}"
    class="form-control"
  ></textarea>
</div>

<!-- Notification Body (English) -->
<div class="form-group">
  <label for="bodyEn">{{ 'MENU.DASHBOARD.notification_content_en' | translate }}</label>
  <textarea
    id="bodyEn"
    [(ngModel)]="formData.body_en"
    name="body_en"
    placeholder="{{ 'MENU.DASHBOARD.notification_content_en' | translate }}"
    class="form-control"
  ></textarea>
</div>
    
           <!-- Recipients -->
  <!-- <div class="form-group">
    <label for="recipients">{{ 'MENU.DASHBOARD.recipients' | translate }}</label>
    <select
      id="recipients"
      [(ngModel)]="formData.recipients"
      name="recipients"
      class="form-select"
    >
      <option value="all">{{ 'MENU.DASHBOARD.all_users' | translate }}</option>
      <option value="premium">{{ 'MENU.DASHBOARD.featured_users' | translate }}</option>
      <option value="new">{{ 'MENU.DASHBOARD.new_users' | translate }}</option>
      <option value="custom">{{ 'MENU.DASHBOARD.custom' | translate }}</option>
    </select>
  </div> -->

  <!-- Notification Type -->
  <div class="form-group">
    <label for="type">{{ 'MENU.DASHBOARD.notification_type' | translate }}</label>
    <select
      id="type"
      [(ngModel)]="formData.type"
      name="type"
      class="form-select"
    >
      <option value="all" selected>{{ 'MENU.DASHBOARD.all_users' | translate }}</option> 
      <option value="investors">{{ 'MENU.DASHBOARD.investors' | translate }}</option>
      <option value="employees">{{ 'MENU.DASHBOARD.employees' | translate }}</option>
      <option value="specific_user">{{ 'MENU.DASHBOARD.specific_user' | translate }}</option>
    </select>
  </div>

<!-- 👇 Appears only if 'specific_user' is selected -->
<div class="form-group mt-3" *ngIf="formData.type === 'specific_user'">
  <label for="userSearch">{{ 'MENU.DASHBOARD.choose_user' | translate }}</label>

  <!-- 🔍 Search Input -->
  <!-- <input
    type="text"
    id="userSearch"
    class="form-control mb-2"
    placeholder="{{ 'MENU.DASHBOARD.search_user' | translate }}"
    (input)="onSearchUser($event.target.value)"
  /> -->

  <!-- 👇 User Dropdown -->
  <select
    id="userSelect"
    [(ngModel)]="formData.user_id"
    name="user_id"
    class="form-select"
  >
    <option value="" disabled selected>{{ 'MENU.DASHBOARD.select_user' | translate }}</option>
    <option *ngFor="let user of pages" [value]="user.id">{{ user.name }}</option>
  </select>
</div>


  <!-- Actions -->
  <div class="actions mt-3 text-center">
    <button
      class="btn"
      id="send-btn"
      style="color: #fff; background-color: #cca44c;"
      (click)="onSubmit()"
    >
      <span>{{ 'MENU.DASHBOARD.send_notification' | translate }}</span>
    </button>
  </div>
</section>
            <!-- <section class="preview-section">
                <h2 class="section-title">معاينة الإشعار</h2>
                <div class="notification-preview" id="notification-preview">
                    <div class="empty-state">
                        <i>🔔</i>
                        <p>سيظهر الإشعار هنا عند المعاينة</p>
                    </div>
                </div>
            </section> -->
        </div>
        
        <!-- <section class="history-section">
            <h2 class="section-title">سجل الإشعارات المرسلة</h2>
            <div class="history-list" id="history-list">
                <div class="empty-state">
                    <i>📋</i>
                    <p>لا توجد إشعارات مرسلة بعد</p>
                </div>
            </div>
        </section> -->
    </div>